import React from "react";
import { Tooltip } from "antd";
import { FaRegCopy } from "react-icons/fa6";
import { PermissionedButton as PermissionedButtonBase } from "@components/PermissionedComponents";
import { IUserDefinedMetric } from "./constants";

const PermissionedButton = PermissionedButtonBase as unknown as React.FC<any>;

interface CopyMetricButtonProps {
    metric: IUserDefinedMetric;
    onDuplicate: (metric: IUserDefinedMetric) => void;
}

export const CopyMetricButton: React.FC<CopyMetricButtonProps> = ({ metric, onDuplicate }) => {
    return (
        <Tooltip title="Create a copy">
            <PermissionedButton
                permissionCheck="ManageUserDefinedMetrics"
                permissionMessage="You don't have permission to manage user defined metrics"
                type="text"
                size="small"
                icon={<FaRegCopy />}
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    onDuplicate(metric);
                }}
            />
        </Tooltip>
    );
};

export default CopyMetricButton;
